import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_Inbox } from '../../../_shared.js';
import './AdvisorPanel_Inbox.scss';
import { Inbox_Filtering } from '../../../_enum/inbox-filter/Inbox_Filtering.js';
import { Component_Inbox } from '../../components/inbox/Component_Inbox/Component_Inbox.js';
export class AdvisorPanel_Inbox extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_Inbox,
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        const className = super.getPanelClass();
        return _className(className, 'panel__inbox');
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => 'Orders';
    renderHeader_Tail = () => {
        return _jsx(_Fragment, { children: _jsx(Inbox_Filtering, { variant: 'concise' }) });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => _jsx(_Fragment, {});
    _renderContent(scrollRef) {
        return _jsx(Component_Inbox, { scrollRef: scrollRef });
    }
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_Inbox.js.map